import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/surat-rujukan-edukasi", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/surat-rujukan-edukasi/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/surat-rujukan-edukasi`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/surat-rujukan-edukasi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDpjp(id: number, data) {
  const response = await http.putData(`/surat-rujukan-edukasi/${id}/sign-dpjp`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signMpp(id: number, data) {
  const response = await http.putData(`/surat-rujukan-edukasi/${id}/sign-mpp`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function listMpp() {
  const response = await http.getData("/combo/mpp").catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response?.data ?? [];
}

async function destroy(id: number) {
  const response = await http.deleteData(`/surat-rujukan-edukasi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/surat-rujukan-edukasi/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  signDpjp,
  signMpp,
  listMpp,
  destroy,
  print
};
